import { useState, useEffect } from 'react';

export default function useEmbedded() {
    const [value, setValue] = useState(sessionStorage.getItem('embedded') === 'true');

    useEffect(() => {
        setValue(sessionStorage.getItem('embedded') === 'true');
    }, []);

    return value;
}